<template>
  <button
    type="button"
    class="integration-copy"
    :aria-label="message || `Copy ${label}`"
    v-tooltip="tip(message || `Copy ${label}`)"
    @click.stop="copy"
  >
    <i v-if="!message" class="pi pi-clipboard" aria-hidden="true" />
    <span v-else role="status">{{ message }}</span>
  </button>
</template>

<script>
import { tooltip } from './model'
export default {
  props: { value: { type: String, required: true }, label: { type: String, default: 'ID' } },
  data: () => ({ message: '', timer: null }),
  beforeDestroy() { clearTimeout(this.timer) },
  methods: {
    tip: tooltip,
    async copy() {
      try {
        await navigator.clipboard.writeText(this.value)
        this.message = 'Copied'
      } catch (error) {
        this.message = 'Copy failed'
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.message = '' }, 2000)
    }
  }
}
</script>
<style scoped lang="scss">
.integration-copy { display: inline-flex; flex: 0 0 auto; align-items: center; justify-content: center; min-width: 28px; min-height: 28px; padding: $ui-space-4; border-radius: $ui-control-radius; color: $ui-muted; background: transparent; cursor: pointer; font-size: $ui-font-size-metadata; }
.integration-copy:hover { color: $ui-blue; background: $ui-blue-soft; }
.integration-copy:focus-visible { outline: 2px solid $ui-blue; outline-offset: 2px; }
.integration-copy .pi { font-size: 17px; }
</style>
